// src/components/icons/MinusBoxIcon.tsx

import React from 'react';

type MinusBoxIconProps = {
  width?: number;
  height?: number;
  className?: string;
};

const MinusBoxIcon: React.FC<MinusBoxIconProps> = ({ width = 18, height = 18, className = '' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M12.6667 8.66667V9.33333H5.33333V8.66667H12.6667ZM1.63603 16.364C2.05544 16.7834 2.57467 17 3.16667 17H14.8333C15.4253 17 15.9446 16.7834 16.364 16.364C16.7834 15.9446 17 15.4253 17 14.8333V3.16667C17 2.57467 16.7834 2.05544 16.364 1.63603C15.9446 1.21662 15.4253 1 14.8333 1H3.16667C2.57467 1 2.05544 1.21662 1.63603 1.63603C1.21662 2.05544 1 2.57467 1 3.16667V14.8333C1 15.4253 1.21662 15.9446 1.63603 16.364Z"
        fill="#00974B"
        stroke="#DAF5EA"
      />
    </svg>
  );
};

export default MinusBoxIcon;
